export default __webpack_public_path__ + "static/media/pic (7).5114674a.jpg";